import { n8nFetch } from './n8n-fetch';
import { WEBHOOK_ENDPOINTS } from '../config/webhook-urls';

// Passthrough в Ozon Seller API — общий для страниц (сборка FBS, «Покупатели»).
// Переехал сюда из pages/ozon-fbs-check.js без изменений, вместе с ретраями 429.

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
// ретраи 429 от Ozon: при ~50 % отказов 6 попыток = ~1 % провалов на вызов, ≤ ~13 с ожидания
const OZON_429_RETRIES = 6;

// Конверт тот же, что у WB fbs-api: {user_id, method, path, body}.
// Лимит Ozon — per Client-Id, общий на все интеграции кабинета (1С и пр.): 429 «rate limit
// per second» прилетает случайно даже на первый запрос после простоя. Ozon отвечает
// retry-after: 1 — ретраим с паузой; 429 = запрос отклонён до обработки, повтор безопасен и для ship.
// opts.retries — сколько раз повторять 429 (0 — сразу вернуть, когда у вызывающего есть запасной путь)
export const ozonApi = async (userId, method, path, body, { retries = OZON_429_RETRIES } = {}) => {
  for (let attempt = 0; ; attempt++) {
    const res = await n8nFetch(WEBHOOK_ENDPOINTS.OZON_FBS_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, method, path, ...(body === undefined ? {} : { body }) }),
    });
    if (!res.ok) throw new Error(`Вебхук ozon-fbs-api вернул HTTP ${res.status}`);
    let data = await res.json();
    if (Array.isArray(data)) data = (data[0] && (data[0].json || data[0])) || {};
    else if (data && data.json) data = data.json;
    const status = Number(data.status) || 0;
    const rate = data.rate || {};
    if (status === 429 && attempt < retries) {
      // Retry-After от Ozon (сек) уважаем, но не дольше 10 с за попытку
      const ra = Math.min(Number(rate['retry-after']) || 0, 10) * 1000;
      await sleep(Math.max(ra, 1200 + 400 * attempt));
      continue;
    }
    const ok = data.ok === undefined ? (status >= 200 && status < 300) : !!data.ok;
    if (!ok && data.error) throw new Error(String(data.error));
    return { ok, status, data: data.data, rate };
  }
};

// 403 от Ozon на методе, который открыт только по подписке (Premium Plus / Premium Pro):
// раздел не ломаем, показываем баннер и ждём, пока подписка появится в кабинете.
export const needsSubscription = (r) => r.status === 403
  && /subscription|premium/i.test(JSON.stringify(r.data || ''));
